import canUse from './canUse'

const GetUser = () =>
    canUse() ? JSON.parse(localStorage.getItem('USER')) : null

export default GetUser
